import React from 'react';

const Default = () => {
    return <div />;
};

Default.propTypes = {};

export default Default;
